import React, { useContext } from 'react';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import CountDownComponent from '../countDownClock';

const TerminalLockReminderPopup = ({ data }) => {
  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small">
      <div className="popup-main-content">
        <CountDownComponent second={data} />
        <p className="text-center">{t('Terminal will be locked soon.')}</p>
      </div>

      <div className="popup-actions">
        <button
          type="button"
          className="popup-confirm-button"
          onClick={closePopup}
        >
          {t('OK')}
        </button>
      </div>
    </div>
  );
};

export default TerminalLockReminderPopup;
